import { Box, CircularProgress } from "@mui/material";
import React from "react";

const FullScreenLoader = ({ text }) => {
  return (
    <>
      <Box
        sx={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          backgroundColor: "rgba(241, 241, 241,0.4)",
          zIndex: 2,
          height: "100vh",
          width: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100%",
            width: "100%",
          }}
        >
          <CircularProgress />
          {text && (
            <p
              style={{
                fontSize: "20px",
                marginLeft: "10px",
                borderRadius: "10px",
                backgroundColor: "white",
                fontWeight: "500",
                padding: "5px 10px",
              }}
            >
              {text}
            </p>
          )}
        </Box>
      </Box>
    </>
  );
};

export default FullScreenLoader;
